import Message from '@/lib/message';

export default {
  checkoutCustomConfig: {
    appClass: { precode: true },
    showCCBText: true,
  },
  preQualifyEventHandler: {
    onReady() {
      Message.post({ ev: 'ready' });
    },
    onSendPreQualifyId(data) {
      Message.post({ ev: 'sendPreQualifyId', data });
    },
    onError() {
      Message.post({ ev: 'error' });
    },
    onVerify(data) {
      Message.post({ ev: 'verifyCredit', data });
    },
    onGoToCheckout() {
      Message.post({ ev: 'modalGoToCheckout' });
    },
    onClosed() {
      Message.post({ ev: 'modalClose' });
    },
  },
  eventHandler: {
    onReady() {
      Message.post({ ev: 'ready' });
    },
    onSuccessCache() {
      Message.post({ ev: 'successCache' });
    },
    onFailCache() {
      Message.post({ ev: 'failCache' });
    },
    onError() {
      Message.post({ ev: 'error' });
    },
    onInstallmentChanged({ installment }) {
      Message.post({ ev: 'installmentChanged', data: installment });
    },
    onOptionsChanged({ options }) {
      const { result } = options;
      Message.post({ ev: result.toLowerCase(), data: options });
    },
    onShippingChanged() {
      Message.post({ ev: 'shippingChangedOk', data: { result: 'ok' } });
    },
    onAuthenticateUser() {
      Message.post({ ev: 'authenticateUser', data: { result: 'ok' } });
    },
  },
};
